import get from 'lodash/get';
import baseState from './baseState';
import tuner from '../tuner';
import listenTimeLogger from '../loggers/listenTime';

const maxWaitTime = 15000;
let currentTune;
let waitTimeout;
let bufferStartTime;
let wasPlaying = false;

function clearWaitTimeout() {
  if (waitTimeout) {
    clearTimeout(waitTimeout);
    waitTimeout = undefined;
  }
}

function transitionToPlayingState(sendBufferReportOnPlay = false) {
  clearWaitTimeout();
  const context = { continueCurrentLogger: true };

  if (sendBufferReportOnPlay) {
    context.bufferStartTime = bufferStartTime;
  }

  tuner.changeState(tuner.states.playing, context);
}

function onPlay() {
  listenTimeLogger.logBuffer(currentTune, bufferStartTime);
  transitionToPlayingState();
}

function onBuffer() {
  transitionToPlayingState(true);
}

function onWaitTimeout() {
  const currentStream = tuner.streamPlayer.getCurrentStream();
  const isBoostStation = get(currentStream, 'isBoostStation', false);
  listenTimeLogger.logFailure(currentTune);

  tuner.trigger(tuner.events.error, {
    message: 'Stream timeout',
    context: {
      streamId: tuner.streamPlayer.getCurrentStreamId(),
    },
  });

  tuner.changeState(tuner.states.connecting, {
    wasPlaying,
    playBoostExperience: isBoostStation,
  });
}

const state = {
  name: 'waiting',
  enter: function (previousState, context = {}) {
    currentTune = context.currentTune;
    wasPlaying = context.wasPlaying || false;
    bufferStartTime = Date.now();
    tuner.trigger(tuner.events.waiting);

    tuner.streamPlayer.on(tuner.streamPlayer.events.play, onPlay);
    tuner.streamPlayer.on(tuner.streamPlayer.events.buffer, onBuffer);

    waitTimeout = setTimeout(onWaitTimeout, maxWaitTime);
  },
  exit: function () {
    clearWaitTimeout();
    bufferStartTime = 0;
    wasPlaying = false;
    tuner.streamPlayer.remove(tuner.streamPlayer.events.play, onPlay);
    tuner.streamPlayer.remove(tuner.streamPlayer.events.buffer, onBuffer);
  },
};

export default {
  ...baseState,
  ...state,
};
